import firebase from '../../../../../../../firebase';
// eslint-disable-next-line
export const fieldChange = (appname, dataId, field, value) => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);

  dataRef.child(field).set(value);

  return {
    type: 'HEADER_FIELD_CHANGE',
    appname,
    dataId,
    field,
    value,
  };
};

export const addNewButton = (appname, dataId) => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);

  const value = {
    gaEnabled: false,
    gaCategory: '',
    gaAction: '',
    link: {
      button: {
        enabled: true,
        label: 'Button',
      },
      enabled: true,
      linkType: {
        email: 'support@beezer.com',
        page: 'about-us',
        phone: '+1-555-555-5555',
        selectedOption: 'page',
        web: 'https://beezer.zendesk.com/hc/en-us',
      },
    },
    design: {
      buttonDesign: {
        backgroundColor: 'rgba(43,75,200,1)',
        border: {
          color: 'rgba(43,41,41,1)',
          style: 'solid',
          width: 0,
        },
        borderRadius: 32,
        color: 'rgba(255,255,255,1)',
        enabled: false,
        textColor: 'rgba(255,255,255,1)',
      },
      enabled: true,
    },
  };

  dataRef.child('extraButtons').push(value);

  return {
    type: 'HEADER_FIELD_CHANGE',
    appname,
    dataId,
  };
};

export const deleteButton = (appname, dataId, key) => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);
  dataRef
    .child('extraButtons')
    .child(key)
    .remove();

  return {
    type: 'HEADER_FIELD_CHANGE',
    appname,
    dataId,
  };
};

export const onChangeNewButton = (appname, dataId, prop, value, key) => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);
  dataRef
    .child('extraButtons')
    .child(key)
    .child(prop)
    .set(value);

  return {
    type: 'HEADER_FIELD_CHANGE',
    appname,
    dataId,
    key,
    prop,
    value,
  };
};

export const designChange = (appname, dataId, field, value) => {
  const dataRef =
    field === 'layout'
      ? firebase.database().ref(`apps/${appname}/draft/always_data/${dataId}`)
      : firebase
          .database()
          .ref(`apps/${appname}/draft/always_data/${dataId}/design`);

  dataRef.child(field).set(value);

  return {
    type: 'BOX_FIELD_CHANGE',
    appname,
    dataId,
    field,
    value,
  };
};

export const extraButtonDesignChange = (appname, dataId, field, value, key) => {
  const dataRef = firebase
    .database()
    .ref(
      `apps/${appname}/draft/lazy_data/${dataId}/extraButtons/${key}/design`,
    );

  dataRef
    .child('buttonDesign')
    .child(field)
    .set(value)
    .then(() => {
      console.log('added');
    })
    .catch(err => {
      console.error(err);
    });

  return {
    type: 'BOX_FIELD_CHANGE',
    appname,
    dataId,
    field,
    value,
  };
};

const receiveGaTrackingId = gaTrackingId => ({
  type: 'RECEIVE_GA_TRACKING_ID',
  data: gaTrackingId,
});

export const loadGoogleAnalytics = appname => async dispatch => {
  const gaRef = firebase.database().ref(`apps/${appname}/gaTrackingId`);
  try {
    const snapshot = await gaRef.once('value');
    const gaTrackingId = await snapshot.val();
    return dispatch(receiveGaTrackingId(gaTrackingId));
  } catch (err) {
    console.error(err);
  }
};
